module.exports = __webpack_public_path__ + "media/step1_animation.6ef87fa0.webm";